const querystring = require('querystring')
const url = require('url')

module.exports = buildUrl

function buildUrl(options) {
  const protocol = options.protocol || 'http'
  const path = options.path || '/'

  const opts = JSON.parse(JSON.stringify(options))

  // We only add the protocol if we have a host/hostname.
  // This way, relavtive paths will still work.
  if (opts.host || opts.hostname) {
    opts.protocol = protocol
  }

  if (opts.path) {
    opts.pathname = path
    delete opts.path
  }

  // Ugh. The current version of `url.format` is broken compared to the Node
  // one (ignores `query`). Handle this.
  if (opts.query) {
    if (typeof opts.query === 'string') {
      // It's already a string. Shunt it into the (working) `search`.
      opts.search = opts.query
    } else {
      // It's an object. Make it into a string.
      opts.search = querystring.stringify(opts.query)
    }

    delete opts.query
  }

  let finalUrl = url.format(opts)

  if (!finalUrl && opts.url) {
    finalUrl = opts.url
  }

  return finalUrl
}
